import { ALL_EXIT_REQUESTS_REG } from "@API/APIRoutes";
import {PENDING_APPROVALS} from "../../API/APIRoutes";
import GenericPendingExitRequests
    from "../RegulatoryMember/PendingExitRequestsFolder/GenericPendingExitRequests/GenericPendingExitRequests";

function PendingApprovalsListing() {
    return <GenericPendingExitRequests API={PENDING_APPROVALS}  title = {"Pending Approvals"} all ={true} readOnly ={true} cancelled={false}/>;
}

export default PendingApprovalsListing;
